import { type Value } from '@discover-use-router-state';
import DEFAULT_SORT from '@discover-data/stores/restaurant/model/sort/default';
import { type SortOption } from '@discover-data/stores/restaurant/model/sort/options';
import isValidSort from './isValid';

export default function getValidSort(routerValues: Value[], sortOptions: readonly SortOption[]) {
  const value = routerValues[0];

  if (isValidSort(value, sortOptions)) {
    return value;
  }

  return DEFAULT_SORT;
}
